import React from "react";
import  { NewMeter } from "./newMeter";
import { MeterReplacement } from "./meterReplacement";
import { MeterRepair } from "./meterRepair";
import { MeterRetrofitting } from "./meterRetrofitting";
import { MeterPreinspection } from "./meterPreinspection";
import { MeterPostInspection } from "./meterPostInspection";
import { MeterDisconnection } from "./meterDisconnection";
import { MeterReconnection } from "./meterReconnection";
import { MeterNormalisation } from "./meterNormalization";
import { MeterRelocation } from "./meterRelocation";

export class WorkDone extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const type = this.props.job.type
    const job = this.props.job

    switch (type) {
      case "new-meter-installation":
        return (<NewMeter job={job}/>)

      case "meter-replacement":
        return (<MeterReplacement job={job}/>)

      case "meter-retrofitting":
        return (<MeterRetrofitting job={job}/>)

      case "meter-repair":
        return (<MeterRepair job={job}/>)

      case "meter-preinspection":
        return (<MeterPreinspection job={job}/>)

      case "meter-post-inspection":
        return (<MeterPostInspection job={job}/>)

      case "meter-disconnection":
        return (<MeterDisconnection job={job}/>)

      case "meter-reconnection":
        return (<MeterReconnection job={job}/>)

      case "meter-relocation":
        return (<MeterRelocation job={job}/>)

      case "meter-normalization":
        return (<MeterNormalisation job={job}/>)

      default:
        return (<div><h1>WorkDone for {type} coming soon</h1></div>)
    }
  }
}
export default (WorkDone);
